<template>
  <div />
</template>

<script>
export default {
  name: 'TicketLogs',
}
</script>
